export default function Band({ label, description, children, className }) {
  return (
    <section className={`band${className ? ' ' + className : ''}`}>
      <div className="band-label">
        <h2 className="band-label-title">{label}</h2>
        {description && <p className="band-label-desc">{description}</p>}
      </div>
      <div className="band-fields">{children}</div>
    </section>
  )
}
